import React, { useState } from "react";
import { Flex } from "@chakra-ui/react";
import useTasks from "../../../hooks/useTasks";
import { useAppContext } from "../../../contexts/AppContext";
import TasksTable from "../../tasks/TasksTable";

const SingleFundTasks = ({ openTaskDrawer, fund }) => {
  const { tasks } = useAppContext();
  const { handleCheckboxChange, justCompletedTasks } = useTasks();

  const relatedTasks = tasks?.filter((task) => task.fund === fund.fundName);

  const [filters, setFilters] = useState({
    status: ["Pending", "Overdue"],
  });

  // 👉 Ici on applique ton filtre local de status
  const filteredTasks = relatedTasks.filter((task) => {
    const selectedStatuses = filters.status || [];

    const taskStatus = task.completed
      ? "Completed"
      : task.dueDate && new Date(task.dueDate) < new Date()
      ? "Overdue"
      : "Pending";

    const matchesStatus =
      selectedStatuses.length === 0 || selectedStatuses.includes(taskStatus);

    return matchesStatus;
  });

  return (
    <Flex direction="column" gap={4}>
      <TasksTable
  tasks={filteredTasks}
  handleCheckboxChange={handleCheckboxChange}
  justCompletedTasks={justCompletedTasks}
  onRowClick={(task) => openTaskDrawer(task)}
  filters={filters}
  setFilters={setFilters}
  extraFilters={{
    status: ["Pending", "Completed", "Overdue"],
  }}
  extraLabelMap={{
    status: "Status",
  }}
/>

  
    </Flex>
  );
};

export default SingleFundTasks;
